import axios from 'axios';

const API_URL = 'https://hellogassy-backend.onrender.com/api/expenses'; // adapte à ton backend

export const expenseService = {
  // 🔹 Récupérer toutes les dépenses
  getAllExpenses: async (token: string) => {
    const response = await axios.get(API_URL, {
         headers: {
        Authorization: `Bearer ${token}`
      },
    });
    
    return response.data;
  },

  // 🔹 Récupérer une dépense par ID
  getExpenseById: async (id: string,token: string) => {
    const response = await axios.get(`${API_URL}/${id}`,{
         headers: {
        Authorization: `Bearer ${token}`
      },
    });
    return response.data;
  },

  // 🔹 Créer une dépense (admin)
  createExpense: async (expenseData: any, token: string) => {
    const response = await axios.post(API_URL, expenseData, {
      headers: {
        Authorization: `Bearer ${token}`
      },
    });
    return response.data;
  },

  // 🔹 Mettre à jour une dépense (admin)
  updateExpense: async (id: string, expenseData: any, token: string) => {
    const response = await axios.put(`${API_URL}/${id}`, expenseData, {
      headers: {
        Authorization: `Bearer ${token}`
      },
    });
    return response.data;
  },

  // 🔹 Supprimer une dépense (admin)
  deleteExpense: async (id: string, token: string) => {
    const response = await axios.delete(`${API_URL}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      },
    });
    return response.data;
  },
};
